/* global window */
import React from 'react'
import styled from 'styled-components'
import * as Feather from 'react-feather'
import { lighten } from 'polished'

import StaggeredFadeIn from 'src/components/StaggeredFadeIn.js'
import { BLACK, RED, WHITE } from 'src/styles/colors.js'

const SharingContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -16px;
`

const ShareColumn = styled.div`
  flex-grow: 1;
  padding: 0 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const ShareButton = styled.button`
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 8px;
  padding: 14px 16px 18px;
  outline: none;
  background: linear-gradient(
    to right,
    ${lighten(0.05, WHITE)},
    ${lighten(0.01, WHITE)}
  );
  border: none;
  border-radius: 4px;
  box-shadow: inset 0 -4px 0 rgba(0, 0, 0, 0.1);
  color: ${BLACK};
  font-family: 'Asap', sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  cursor: pointer;

  &:hover {
    background-image: linear-gradient(to right, #fefefe, #fefefe);
    color: ${RED};
  }

  svg {
    margin-right: 8px;
  }
`

function getAnimationStyles(interpolatedStyle) {
  return {
    opacity: interpolatedStyle.opacity || 1,
  }
}

const SHARE_URL = 'http://loftet.tillsammansskapet.se'
const SHARE_URL_ENCODED = window.encodeURIComponent(SHARE_URL)
const SHARE_BODY_QUOTE =
  'Det är inte politikerna som kommer leda oss in i framtiden, det är vi som kommer leda dem. Det här är det sociala löftet.'
const SHARE_BODY_PERSONAL =
  'Jag skrev under Det sociala löftet. Det är vi som kommer leda oss in i framtiden, inte politikerna. Gör det du också!'

/**
 * Sharing
 */
const Sharing = () => (
  <StaggeredFadeIn numElements={3} stiffness={200} damping={50}>
    {interpolatingStyles => (
      <SharingContainer>
        <ShareColumn style={getAnimationStyles(interpolatingStyles[0])}>
          <ShareButton
            onClick={() =>
              window.open(
                `https://www.facebook.com/dialog/share?app_id=258971128092211&display=popup&href=${SHARE_URL_ENCODED}&quote=${SHARE_BODY_QUOTE}&hashtag=#detsocialalöftet`,
                '_blank',
                'width=550,height=450'
              )
            }
          >
            <Feather.Facebook size={16} /> Dela på Facebook
          </ShareButton>
        </ShareColumn>

        <ShareColumn style={getAnimationStyles(interpolatingStyles[1])}>
          <ShareButton
            onClick={() =>
              window.open(
                `https://twitter.com/intent/tweet?text=${SHARE_BODY_PERSONAL}&url=${SHARE_URL_ENCODED}&hashtags=detsocialalöftet`,
                '_blank',
                'width=550,height=450'
              )
            }
          >
            <Feather.Twitter size={16} /> Twittra om löftet
          </ShareButton>
        </ShareColumn>

        <ShareColumn style={getAnimationStyles(interpolatingStyles[2])}>
          <ShareButton
            onClick={() =>
              window.open(
                `mailto:?subject=Skriv under Det sociala löftet&body=${SHARE_BODY_PERSONAL} ${SHARE_URL}`,
                '_self'
              )
            }
          >
            <Feather.Mail size={16} /> Skicka via email
          </ShareButton>
        </ShareColumn>
      </SharingContainer>
    )}
  </StaggeredFadeIn>
)

export default Sharing
